module.exports = __webpack_public_path__ + "static/media/stripe-create-account_8.f056fc41.png";